

export class CostEstimationStatus {
    static InProgress = 1;
    static SentToAcceptation = 2;
    static Accepted = 3;
    static Rejected = 4;
    static Removed = 5;
  }
